import Col from './Col.style'

export default Col